module.exports = __webpack_public_path__ + "static/media/consultoria1.922fef73.jpg";